var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransitionGroup',{staticClass:"row flex-wrap",attrs:{"name":"group-list","tag":"li"}},_vm._l((_vm.list),function(item,index){return _c('li',{key:item.id,class:[
      'list-item',
      {
        'is-dragover': index == _vm.dropIndex && item.draggable && _vm.config.exchange
      },
    ],attrs:{"draggable":item.draggable},on:{"dragstart":function($event){return _vm.onDragstart($event, index)},"dragenter":function($event){return _vm.onDragenter(index)},"dragover":function($event){$event.preventDefault();return _vm.onDragover(index)},"dragleave":_vm.onDragleave,"dragend":_vm.onDragend,"drop":_vm.onDrop}},[_vm._t("default",null,{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }